<template>
    <div>
        
    </div>
</template>

<script>
    import axios from "axios";
    export default {
        name: 'Hitmap',
        computed: {
           
        },
        methods: {
            /*
            Cabeçalho:
            x-api-key: fa65be02-f607-45ea-879d-46feaaf8e24f

            [{
                "xy": [765, 2760],
                "context": "web",
                "timestamp": 1608667765070,
                "visitableId": "-mp4zuby_oqxhebkwpf0",
                "mapId": "-mp4zuby_oqxhebkwpf0-floor0",
                "floorId": "0",
                "device": "samsung_SM-G570M_Android_8.0.0",
                "userId": "1dd84c04b44f4f4b_4200b2a501cf3521"
            }]
            */
            send()
            {
                console.log('send');
                
                let timestamp = new Date().getTime();

                let headers = { 
                    'Content-Type': 'application/json;charset=UTF-8', 
                    'Access-Control-Allow-Origin': '*', 
                    'Access': 'application/json',
                    'x-api-key': 'fa65be02-f607-45ea-879d-46feaaf8e24f' };

                let form_data = new FormData();
                    form_data.append('xy', [0, 0]);
                    form_data.append('context', 'web');
                    form_data.append('timestamp', timestamp);
                    form_data.append('visitableId', '');
                    form_data.append('mapId', '');
                    form_data.append('floorId', '');
                    form_data.append('device', '');
                    form_data.append('userId', '');

                form_data = new FormData();

                axios.get('https://api.analytics.zapt.tech/v1/userLocation', form_data, headers).then(response => this.addResponse(response));
            }
        },
        mounted() {
            //this.load();
        },
        updated() {
            //this.btn_submit_value = this.$ml.get('produto.add');
        }
    }
</script>

